import { defineComponent as s, computed as l, openBlock as a, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as f, normalizeStyle as v, createStaticVNode as n } from "vue";
const p = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "45d12773-c499-489f-8dda-c7f446ac4b85" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#45d12773-c499-489f-8dda-c7f446ac4b85)" }, g = { key: 0 }, k = /* @__PURE__ */ n('<path fill="#0052b4" d="M256 0h256v512H0V256Z"></path><path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"></path><path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"></path><path fill="#eee" d="M288 288v32h32v8h96v-8h32v-32h-32v8h-96v-8zm32-144 48-80 48 80z"></path><circle cx="368" cy="144" r="48" fill="#338af3"></circle><path fill="#338af3" d="M320 144v48l48 32 48-32v-48z"></path><rect width="32" height="128" x="288" y="128" fill="#ff9811" rx="16" ry="16"></rect><rect width="32" height="128" x="416" y="128" fill="#ff9811" rx="16" ry="16"></rect><path fill="#eee" d="M320 192v29c0 36 48 48 48 48s48-12 48-48v-29zm48-48-16 48h32z"></path><path fill="#338af3" d="m352 192 16 48 16-48z"></path>', 10), u = { fill: "none" }, x = ["r"], V = /* @__PURE__ */ s({
  __name: "sh-ta",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(h) {
    const e = h, o = l(() => 512 + 2 * e.strokeWidth), c = l(() => -e.strokeWidth), r = l(() => 256 + e.strokeWidth / 2);
    return (y, w) => (a(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${o.value} ${o.value}`
    }, [
      m,
      t("g", _, [
        e.flagName ? (a(), i("title", g, d(e.flagName), 1)) : f("", !0),
        k
      ]),
      t("g", u, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: v({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, p));
  }
});
export {
  V as default
};
//# sourceMappingURL=sh-ta-08101177.js.map
